var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.4835 23.7039C52.7101 11.3573 41.9368 5.83728 32.4968 5.83728C32.4968 5.83728 32.4968 5.83728 32.4701 5.83728C23.0567 5.83728 12.3101 11.3573 9.51005 23.6773C6.36338 37.4373 14.79 49.0906 22.4167 56.4506C25.2434 59.1706 28.8701 60.5306 32.4968 60.5306C36.1235 60.5306 39.7501 59.1706 42.5501 56.4506C50.1768 49.0906 58.6035 37.4639 55.4835 23.7039ZM41.2435 25.9173L30.5768 36.5839C30.1768 36.9839 29.6701 37.1706 29.1635 37.1706C28.6568 37.1706 28.1501 36.9839 27.7501 36.5839L23.75 32.5839C22.9767 31.8106 22.9767 30.5306 23.75 29.7573C24.5234 28.9839 25.8034 28.9839 26.5767 29.7573L29.1635 32.3439L38.4168 23.0906C39.1901 22.3173 40.4701 22.3173 41.2435 23.0906C42.0168 23.8639 42.0168 25.1439 41.2435 25.9173Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTick);
export default __webpack_public_path__ + "static/media/location-tick.1a4ddee5eb9e03c821fd477cca4fce2a.svg";
export { ForwardRef as ReactComponent };